import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { FeatureConfigService } from 'services/FeatureConfigService';
import { useInjection } from 'services/ioc/ioc.react';
import { ContextStore } from 'stores/ContextStore';
import { DualSystemBadge, OrgInfoCardWrapper, OrganizationName, StadiumName } from './OrgInfoCardStyles';

export const OrgInfoCard: React.FC = observer(() => {
  const contextStore = useInjection<ContextStore>(ServiceTypes.ContextStore);
  const featureConfigService = useInjection<FeatureConfigService>(ServiceTypes.FeatureConfigService);

  return (
    <OrgInfoCardWrapper>
      <StadiumName>{contextStore.activeField?.fieldName}</StadiumName>
      <OrganizationName>{contextStore.activeField?.venueName}</OrganizationName>
      {featureConfigService.getConfig().isDualSystemArmingEnabled && <DualSystemBadge>Dual System Enabled</DualSystemBadge>}
    </OrgInfoCardWrapper>
  );
});
